"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Emil PublicAPI
 * The Emil Public API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePresignedPostRequestDtoContentTypeEnum = exports.CreatePresignedPostRequestDtoRequesterEnum = void 0;
exports.CreatePresignedPostRequestDtoRequesterEnum = {
    Accountservice: 'accountservice',
    Insuranceservice: 'insuranceservice',
    Billingservice: 'billingservice',
    Tenantservice: 'tenantservice',
    BookingFunnel: 'bookingFunnel',
    Publicapi: 'publicapi',
    Admin: 'admin',
    Claimservice: 'claimservice',
    Customerservice: 'customerservice',
    Notificationservice: 'notificationservice',
    Paymentservice: 'paymentservice',
    Processmanager: 'processmanager',
    Gdvservice: 'gdvservice',
    Documentservice: 'documentservice'
};
exports.CreatePresignedPostRequestDtoContentTypeEnum = {
    Pdf: 'pdf',
    Jpg: 'jpg',
    Png: 'png',
    Gz: 'gz',
    Csv: 'csv',
    Doc: 'doc',
    Docx: 'docx',
    Html: 'html',
    Json: 'json',
    Xml: 'xml',
    Txt: 'txt',
    Zip: 'zip',
    Tar: 'tar',
    Rar: 'rar',
    Mp4: 'MP4',
    Mov: 'MOV',
    Wmv: 'WMV',
    Avi: 'AVI'
};
